export { COOKIE_NAME, ONE_YEAR_MS } from "@shared/const";

/**
 * The login URL.
 *
 * This used to build a redirect into the Manus OAuth portal from
 * VITE_OAUTH_PORTAL_URL and VITE_APP_ID. Both are gone with the Manus platform,
 * and password auth is now the only login path.
 *
 * It points at /login, the dedicated sign-in page. It used to point at /auth,
 * which renders the directory with the sign-in dialog over it: the right screen
 * for someone already browsing, the wrong one for someone following a link that
 * said "log in". /auth still works and is unchanged, because it is in every
 * welcome email sent before Aug 2026.
 *
 * The server exposes the same URL in absolute form via auth.loginUrl for
 * GoHighLevel's [LOGIN LINK] placeholder.
 */
export const getLoginUrl = (returnTo?: string) => {
  const path = "/login";
  if (!returnTo) return path;
  return `${path}?returnTo=${encodeURIComponent(returnTo)}`;
};
